import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useSourceDocumentTypeBadgeStyles = makeStyles({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    padding: `2px ${designTokens.spacing[2]}`,
    borderRadius: designTokens.borderRadius.full,
    fontFamily: projectIqTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    lineHeight: designTokens.lineHeight.normal,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  toneSow: {
    backgroundColor: designTokens.semantic.successLight,
    color: designTokens.semantic.successDark,
  },
  toneProposal: {
    backgroundColor: designTokens.semantic.infoLight,
    color: projectIqTokens.workspaceStatusColors.blue,
  },
  toneChangeOrder: {
    backgroundColor: designTokens.semantic.errorLight,
    color: designTokens.semantic.error,
  },
  tonePurchaseOrder: {
    backgroundColor: designTokens.semantic.warningLight,
    color: designTokens.semantic.warningDark,
  },
  toneExtension: {
    backgroundColor: projectIqTokens.violetBg,
    color: projectIqTokens.violetInk,
  },
  toneNeutral: {
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.ink3,
  },
});
